import { Service } 		from "./../../Libs/Service";
import _ from "lodash";

let Metadata = new Service({

	Name: "Metadata",

	Events: {

	},

	Actions: {

		//Получение метаданных из БД
		'Metadata': function(metadata) {

			_.extend(this, metadata);

			this.TemplatesByCodename = _.keyBy(metadata.Templates, 'codename');

			_.each(this.TemplateAssets, templateAsset => {

				templateAsset.timestamp = new Date(templateAsset.timestamp);

				templateAsset.isPNG = (templateAsset.type === 'image' && templateAsset.url.toLowerCase().indexOf('png') > -1);
				templateAsset.isJPG = (templateAsset.type === 'image' && templateAsset.url.toLowerCase().indexOf('jpg') > -1);
				templateAsset.isSVG = (templateAsset.type === 'svg' && templateAsset.url.toLowerCase().indexOf('svg') > - 1);

			});

			this.TemplateAssetsByTemplateId = _.mapValues(_.groupBy(this.TemplateAssets, "template_id"), a => _.keyBy(a, "id"));
			this.TemplateAssetsByTemplateIdByCodename = _.mapValues(_.groupBy(this.TemplateAssets, "template_id"), a => _.keyBy(a, "codename"));

			this.TemplateSectionsByTemplateId = _.mapValues(_.groupBy(this.TemplateSections, "template_id"), a => _.keyBy(a, "id"));
			this.TemplateSectionsByTemplateIdByCodename = _.mapValues(_.groupBy(this.TemplateSections, "template_id"), a => _.keyBy(a, "codename"));

			this.TemplateSettingsByTemplateId = _.mapValues(_.groupBy(this.TemplateSettings, "template_id"), a => _.keyBy(a, "id"));
			this.TemplateSettingsByTemplateIdByCodename = _.mapValues(_.groupBy(this.TemplateSettings, "template_id"), a => _.keyBy(a, "codename"));

			if (Template.SelectedTemplate) Template.SelectedTemplate = this.Templates[Template.SelectedTemplate.id];

			Broadcast.call("Metadata Loaded");

		}

	},

	init() {

	}

});

//Только для наблюдения за состоянием через консоль браузера
window.Metadata = Metadata;

export { Metadata };

